import React from "react";
import { Tooltip, Typography } from "@mui/material";

type CustomTooltipProps = {
  text: string;
  maxLength?: number;
  color?: string;
  bgColor?: string;
  fontSize?: string;
  fontWeight?: number;
};

const CustomTooltip: React.FC<CustomTooltipProps> = ({
  text,
  maxLength = 1000,
  color = "#ffffff",
  bgColor = "#333",
  fontSize = "14px",
  fontWeight,
}) => {
  return (
    <Tooltip
      title={text}
      arrow
      placement="top"
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: bgColor,
            color: "#fff",
            textAlign: "left",
            fontSize: "12px !important",
            padding: "18px 25px",
            border: "1px solid #cccccc",
          },
        },
      }}
    >
      <Typography
        component="span"
        style={{
          color: color,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          textAlign: "center",
          fontSize: fontSize,
          fontWeight: fontWeight,
        }}
      >
        {text.length > maxLength
          ? text.substring(0, maxLength).concat("...")
          : text}
      </Typography>
    </Tooltip>
  );
};

export default CustomTooltip;
